<template>
  <div class="flex">
    <!-- Backdrop -->
    <div
      :class="isOpen ? 'block' : 'hidden'"
      @click="$emit('closeMenu')"
      class="fixed inset-0 z-20 transition-opacity bg-black/50 lg:hidden"
    ></div>
    <!-- End Backdrop -->

    <div
      :class="isOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'"
      class="fixed inset-y-0 left-0 z-30 flex w-64 flex-col overflow-y-auto transition duration-300 transform bg-gradient-to-br from-ink to-ink-3 lg:translate-x-0 lg:static lg:inset-0"
    >
      <router-link class="flex items-center gap-3 px-6 pt-7 pb-2" to="/dashboard">
        <img src="@/assets/img/logo.svg" alt="Logo gesti" class="h-8 w-auto"/>
        <span class="text-xl font-semibold text-on-ink">Gesti</span>
      </router-link>

      <nav class="flex-1 px-4 mt-6 space-y-1">
        <router-link
          v-for="item in navItems"
          :key="item.label"
          :to="item.to"
          class="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors"
          :class="item.routes.includes($route.name) ? 'bg-indigo-600 text-white' : 'text-on-ink-muted hover:bg-ink-2 hover:text-on-ink'"
        >
          <font-awesome-icon :icon="item.icon" class="w-4 h-4 flex-none"/>
          {{ item.label }}
        </router-link>
      </nav>

      <div class="mb-4 text-center text-xs text-on-ink-muted">
        v{{ appVersion }}
      </div>

      <div class="mx-4 mb-4 flex items-center gap-3 rounded-lg bg-ink-2 px-3 py-2.5">
        <router-link to="/profil" class="flex min-w-0 flex-1 items-center gap-3">
          <span
            class="flex h-8 w-8 flex-none items-center justify-center rounded-full text-xs font-semibold"
            :class="userColor"
          >{{ userInitials }}</span>
          <span class="truncate text-sm font-medium text-on-ink">{{ userName }}</span>
        </router-link>
        <router-link
          to="/logout"
          class="flex h-8 w-8 flex-none items-center justify-center rounded-md text-on-ink-muted transition-colors hover:bg-ink-3 hover:text-on-ink"
          title="Se déconnecter"
          aria-label="Se déconnecter"
        >
          <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="w-4 h-4"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            navItems: [
                {
                    label: 'Dashboard',
                    to: '/dashboard',
                    icon: ['fas', 'chart-pie'],
                    routes: ['dashboard'],
                },
                {
                    label: 'Mes Biens',
                    to: '/bien',
                    icon: ['fa', 'home'],
                    routes: ['bien', 'bienDetails', 'bienDetailsDetails', 'bienDetailsLocataires', 'bienDetailsFinancials', 'bienDetailsBiens', 'bienDetailsSettings'],
                },
                {
                    label: 'Mes Locataires',
                    to: '/locataires',
                    icon: ['fa', 'users'],
                    routes: ['locataire', 'locataireDetails', 'locataireDetailsDetails'],
                },
                {
                    label: 'Mes Sci',
                    to: '/sci',
                    icon: ['fa', 'briefcase'],
                    routes: ['sci', 'sciDetails', 'sciDetailsDetails', 'sciDetailsBiens', 'sciDetailsSettings'],
                },
            ],
        }
    },
    emits: ['closeMenu'],
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        userInitials() {
            return this.$store.state.auth.user?.initials || '';
        },
        userName() {
            return this.$store.state.auth.user?.name || 'Mon profil';
        },
        userColor() {
            if (this.$store.state.auth.user && this.$store.state.auth.user.color) {
                return `bg-${this.$store.state.auth.user.color} text-white`;
            }

            return 'bg-ink-3 text-on-ink';
        },
        appVersion() {
            return '1.1.0';
        },
    },
};
</script>
